{
  "SET_NEW_PASSWORD": {
    "TITLE": "Új jelszó megadása",
    "PASSWORD": {
      "LABEL": "Jelszó",
      "PLACEHOLDER": "Jelszó",
      "ERROR": "A jelszó túl rövid."
    },
    "CONFIRM_PASSWORD": {
      "LABEL": "Jelszó megerősítése",
      "PLACEHOLDER": "Jelszó megerősítése",
      "ERROR": "A jelszavak nem egyeznek."
    },
    "API": {
      "SUCCESS_MESSAGE": "Jelszó sikeresen megváltoztatva.",
      "ERROR_MESSAGE": "Nem sikerült csatlakozni a Woot szerverhez, kérjük próbáld később"
    },
    "CAPTCHA": {
      "ERROR": "Az időlimit lejárt, kérlek oldd meg újra a captchát."
    },
    "SUBMIT": "Elküldés"
  }
}
